import React from "react";
import "./Help.css";
import { FaBed, FaChild, FaExchangeAlt, FaTimesCircle } from "react-icons/fa";

const HelpRoomTypes = () => {
  return (
    <section className="helpSection p-3">
      <div className="container-xl">
        <div className="helpHeader mb-4">
          <h2 className="fw-bold text-dark">Room Types</h2>
          <p className="text-muted">
            Learn about different room types, bed options, cancellation policies, and extra beds or cots.
          </p>
        </div>

        <div className="helpContent">
          {/* 1 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaBed />
            </div>
            <div className="helpText">
              <h5>What’s the difference between a Double Room and a Twin Room?</h5>
              <p>
                A Double Room includes one double or queen-size bed, while a Twin Room has two separate single beds.
              </p>
              <p>
                If a room is listed as “Double/Twin,” it can be arranged either way depending on your preference.
                You can mention your bed choice in the “Special Requests” section while booking on YOVHO.com.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaTimesCircle />
            </div>
            <div className="helpText">
              <h5>What do “Non-Refundable” and “Free Cancellation” mean?</h5>
              <p>
                Every property sets its own cancellation policy. A Non-Refundable booking means a fee applies if you cancel or change your stay.
                A Free Cancellation booking allows you to cancel without paying anything, as long as it’s within the time limit set by the property.
              </p>
              <p>
                Always review these details before confirming your booking to avoid confusion.
              </p>
            </div>
          </div>

          {/* 3 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaExchangeAlt />
            </div>
            <div className="helpText">
              <h5>Can I request an extra bed for my room? Will there be an extra charge?</h5>
              <p>
                Extra bed details are listed under the “House Rules” on the property page. If available, there may be a small additional charge.
                You can request an extra bed during booking under “Special Requests” or contact the property after booking.
              </p>
              <p>
                We recommend confirming with the property before arrival so they can prepare your room accordingly.
              </p>
            </div>
          </div>

          {/* 4 */}
          <div className="helpItem">
            <div className="helpIcon">
              <FaChild />
            </div>
            <div className="helpText">
              <h5>Can I get an extra bed or baby cot for a child?</h5>
              <p>
                Information about extra beds and baby cots is listed under the property’s “House Rules.” Some may be free, others may have a small fee.
              </p>
              <p>
                You can request a baby cot or extra bed when booking or contact the property after your reservation.
                Checking in advance ensures your host can prepare everything before you arrive.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HelpRoomTypes;
